'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

LoginConfig=class LoginConfig{
static get $inject(){return['$stateProvider','$urlMatcherFactoryProvider']}

constructor($stateProvider,$urlMatcherFactoryProvider){
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateFeatureConfig('login',{
url:'/login?state&passwordResetRequest&return_to',
reloadOnSearch:!1,
params:{
sessionHasExpired:!1,
state:'login',
return_to:null},

views:{
"header@":{}}});


$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=LoginConfig;
//# sourceMappingURL=loginConfig.js.map
